<ng-container *ngIf="display$ | async as display">
  <section [class.open]="display === 'open'" (click)="close()">
    <div (click)="$event.stopPropagation()">
      <button class="close" type="button" (click)="close()">X</button>
      <app-contentful-rich-text [document]="content.json"></app-contentful-rich-text>
      <button class="btn primary-button" type="button" (click)="close()">CONTINUE</button>
    </div>    
  </section>
</ng-container>
